'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @module UI/constants
 */

/**
 * @readonly
 * @type {string}
 */
var VISIBILITY_HIDDEN = exports.VISIBILITY_HIDDEN = 'hidden';

/**
 * @readonly
 * @type {string}
 */
var VISIBILITY_VISIBLE = exports.VISIBILITY_VISIBLE = 'visible';

/**
 * @readonly
 * @type {string}
 */
var STATE_READY = exports.STATE_READY = 'ready';

/**
 * @readonly
 * @type {string}
 */
var STATE_ERROR = exports.STATE_ERROR = 'visible';

/**
 * @readonly
 * @type {string}
 */
var STATE_LOADING = exports.STATE_LOADING = 'loading';

/**
 * @readonly
 * @type {string}
 */
var STATE_EMPTY = exports.STATE_EMPTY = 'empty';

/**
 * @readonly
 * @type {string}
 */
var STATE_PARTIAL = exports.STATE_PARTIAL = 'partial';

/**
 * @readonly
 * @type {string}
 */
var DISPLAY_COLLAPSED = exports.DISPLAY_COLLAPSED = 'collapsed';

/**
 * @readonly
 * @type {string}
 */
var DISPLAY_EXPANDED = exports.DISPLAY_EXPANDED = 'expanded';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/UI/constants.js
// module id = 167
// module chunks = 0